<div class="">
  <header>
    <div class="upper">
      <div class="inner">
        <div class="kode_top_logo">
          <span class="gst-logo"
            ><a> <img src="../../assets/images/GSTAT-Logo.png" /></a></span
          ><a href="#"> </a>
          <div class="logo-title">
            <a href="#">
              <img src="../../assets/images/ashoka_emblem_lite.png" />
            </a>
            <h1>
              <a href="#">
                GSTAT Appellate Tribunal<br />
                <span class="subtitle"
                  >Government of India, States and Union Territories</span
                ></a
              >
            </h1>
          </div>
        </div>
        <div class="right_logo">
          <img src="../../assets/images/logo_sb.png" />
          <img src="../../assets/images/logo_di.png" />
        </div>
      </div>
    </div>
  </header>
  <form [formGroup]="surveyForm">
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="container feed-br">
          <div class="row head-div">
            <div class="col-md-6">
              <h4>
                <span id="lblFeedback">Remark Form</span>
              </h4>
            </div>
            <div class="col-md-3 text-right"></div>
            <div class="col-md-3"></div>
          </div>
          <div class="clear-10"></div>
          <div class="portlet-body form">
            <div class="main-feedback2">
              <div class="clear-20"></div>
              <div class="row input_box_2 fn-lb" align="center">
                <span id="lblSearchMsg" class="label"></span>
                <p align="left"><span id="lblTaxPayer">Dear Taxpayer</span>,</p>
                <br />
                <p align="left">
                  <span id="lblhead1">
                    Thank you for your input. We are re-opening your ticket for
                    further actioning. Kindly share the reason(s) on, why is
                    that the resolution given to your ticket is not to your
                    satisfaction.</span
                  >
                  <span id="lblticket"></span>
                </p>
                <div class="clearfix"></div>
              </div>
              <div class="main-feedback">
                <div class="form-group questionnaire">
                  <div class="clear-20"></div>
                  <span id="lblQuestion7" class="label-bold">Remark :</span>
                  <textarea
                    name=""
                    rows="4"
                    formControlName="feedback"
                    cols="20"
                    maxlength="5000"
                    id=""
                    class="form-control"
                  ></textarea>
                  <div class="clearfix"></div>
                </div>

                <div class="form-group questionnaire" align="center">
                  <div class="clear-20"></div>
                  <input
                    type="submit"
                    (click)="submit()"
                    name="btnSubmit"
                    value="Submit"
                    id="btnSubmit"
                    class="btn btn-primary btn-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      class="panel panel-default d-flex justify-content-center align-content-center errorDiv"
      *ngIf="!this.interactionId"
    >
      <img src="../../assets/images/404error.jpg" class="w-50" />
    </div> -->
  </form>
</div>
